import React from 'react';
import { createRoot } from 'react-dom/client';

import SentryService from 'libs/Sentry';

import 'assets/third-party/apex-chart.css';

import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import AppProvider from './store/AppProvider';
import 'simplebar/dist/simplebar.min.css';

SentryService.init();

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
    <React.StrictMode>
        <AppProvider>
            <ErrorBoundary>
                <App />
            </ErrorBoundary>
        </AppProvider>
    </React.StrictMode>
);
